// 面ごとの強さの倍率。敵（battle の stageTune）と推奨戦力（meta の recommendedPower）の両方に同じだけ掛ける。
// 1〜45面（最初の1週間）は tools/sim/fit-schedule.ts が目標の進み（何日目に何面）に合わせて書き直す（BALANCE.md 53章）。
// それより先は砦・本城を同じ地方の最後の陣の1.1倍までに抑える分（52章）。
export const STAGE_TUNE: Record<number, number> = {
  2: 1.451,
  3: 0.932,
  4: 1.257,
  5: 0.813,
  6: 1.157,
  7: 0.735,
  8: 1.054,
  9: 0.689,
  10: 1.082,
  11: 1.168,
  12: 1.717,
  13: 1.142,
  14: 1.613,
  15: 0.989,
  16: 1.449,
  17: 0.937,
  18: 1.344,
  19: 0.894,
  20: 1.128,
  21: 1.109,
  22: 1.683,
  23: 1.025,
  24: 1.504,
  25: 0.963,
  26: 1.355,
  27: 0.919,
  28: 1.325,
  29: 0.873,
  30: 1.049,
  31: 0.853,
  32: 0.877,
  33: 0.788,
  34: 0.813,
  35: 0.725,
  36: 0.78,
  37: 0.652,
  38: 0.708,
  39: 0.616,
  40: 0.613,
  41: 0.789,
  42: 0.958,
  43: 0.797,
  44: 0.867,
  45: 0.72,
  46: 0.818,
  47: 0.732,
  48: 0.839,
  49: 0.725,
  50: 0.854,
  60: 0.954,
  61: 0.68,
  62: 0.724,
  63: 0.766,
  64: 0.816,
  65: 0.868,
  66: 0.922,
  67: 0.98,
  70: 0.954,
  71: 0.631,
  72: 0.671,
  73: 0.712,
  74: 0.761,
  75: 0.814,
  76: 0.871,
  77: 0.931,
  78: 0.988,
  80: 0.856,
  90: 0.917,
  100: 0.954,
};
